import { createBrowserRouter } from 'react-router'

import Layout from './components/Layout/Layout'
import Home from './pages/Home'
import Login from './pages/Login'
import Notfound from './pages/Notfound'
import UserEntries from './pages/UserEntries'
import Users from './pages/Users'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: '/login',
    element: (
      <Layout>
        <Login />
      </Layout>
    ),
  },
  {
    path: '/users',
    element: (
      <Layout>
        <Users />
      </Layout>
    ),
  },
  {
    path: '/users/:id',
    element: (
      <Layout>
        <UserEntries />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
])

export default router
